// Qual arquivo da marca usar e em que tamanho, lido do marca.json (packages/ui/marca): o horizontal ou o símbolo, para
// fundo escuro ou claro. O componente Marca (React, jogo e admin) e o Marca.astro do site usam esta escolha.
import marca from '../marca/marca.json' with { type: 'json' };

export type VarianteDaMarca = 'horizontal' | 'simbolo';
export type FundoDaMarca = 'escuro' | 'claro';
export interface MarcaEscolhida { arquivo: string; largura: number; altura: number; respiro: number }

export const ALT_DA_MARCA = marca.regras.alt;
export const NOME_DO_LINK_DA_MARCA = marca.regras.linkParaOInicio;
const ARQUIVOS: Record<string, { proporcao: number }> = marca.arquivos;

// A altura em px. Abaixo de 120 px de largura, o horizontal dá lugar ao símbolo. O respiro (o espaço livre em volta)
// é de 25% da altura.
export function escolherMarca(variante: VarianteDaMarca, fundo: FundoDaMarca, altura: number): MarcaEscolhida {
  let arquivo = marca.marca[variante][fundo];
  if (variante === 'horizontal' && altura * ARQUIVOS[arquivo]!.proporcao < marca.regras.larguraMinimaDoHorizontal) arquivo = marca.marca.simbolo[fundo];
  return { arquivo, largura: Math.round(altura * ARQUIVOS[arquivo]!.proporcao), altura, respiro: Math.ceil(altura * marca.regras.respiro) };
}
